import React, { useEffect, useState, useMemo } from "react";
import moment from "moment";

import { allTasksApi, apiRemoveTasks, apiTaskTimeExport } from "../../../../services/Admin/calendar";
import { addTransaction } from "../../../../services/Admin/transaction";
import { apiGetMediaElement } from "../../../../services/Admin/media";


import TableFilterBase from "../../../../components/Admin/TableFilterBaser";
import timestampToDate from "../../../../components/timestampToDate";
import DifferenceDate from "../../../../components/DifferenceDate";
import LoadingProgress from "../../../../components/LoadingProgress";
import downloaderFile from "../../../../utils/downloaderFile";
import Card from "../../../../components/Admin/Card";
import { getMimeTypeByFormat } from "../../../../components/Admin/Media/mediaUtils";

import Box from "@mui/material/Box";
import Link from "@mui/material/Link";
import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";
import Switch from "@mui/material/Switch";
import Dialog from '@mui/material/Dialog';
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import { CircularProgress, Modal } from "@mui/material";
import FormControlLabel from "@mui/material/FormControlLabel";

import EditTask from "../../Calendario/Fields";

const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    bgcolor: "background.paper",
    boxShadow: 20,
    p: 4,
    minWidth: 400,
    maxWidth: 400,
    borderRadius: 3,
    position: "relative"
};


// This is a custom filter UI for selecting
// a unique option from a list
function SelectColumnFilter({
    column: { filterValue, setFilter, preFilteredRows, id },
}) {
    // Calculate the options for filtering
    // using the preFilteredRows
    const options = React.useMemo(() => {
        const options = new Set()
        preFilteredRows.forEach(row => {
            options.add(row.values[id])
        })
        return [...options.values()]
    }, [id, preFilteredRows])

    // Render a multi-select box
    return (
        <select
            value={filterValue}
            //className={"form-control"}
            onChange={e => {
                setFilter(e.target.value || undefined)
            }}
        >
            <option value="">Todos</option>
            {options.map((option, i) => (
                <option key={i} value={option}>
                    {option}
                </option>
            ))}
        </select>
    )
}

function DateRangeColumnFilter({
    column: {
        filterValue = [],
        preFilteredRows,
        setFilter,
        id
    }
}) {
    const [min, max] = React.useMemo(() => {
        let min = preFilteredRows.length ? new Date(preFilteredRows[0].values[id]) : new Date(0)
        let max = preFilteredRows.length ? new Date(preFilteredRows[0].values[id]) : new Date(0)

        preFilteredRows.forEach(row => {
            const rowDate = new Date(row.values[id])

            min = rowDate <= min ? rowDate : min
            max = rowDate >= max ? rowDate : max

        })

        return [min, max]
    }, [id, preFilteredRows])

    return (
        <div>
            <input
                min={min.toISOString().slice(0, 10)}
                onChange={e => {
                    const val = e.target.value
                    setFilter((old = []) => [val ? val : undefined, old[1]])
                }}
                type="date"
                value={filterValue[0] || ''}
            />
            {' to '}
            <input
                max={max.toISOString().slice(0, 10)}
                onChange={e => {
                    const val = e.target.value
                    setFilter((old = []) => [old[0], val ? val.concat('T23:59:59.999Z') : undefined])
                }}
                type="date"
                value={filterValue[1]?.slice(0, 10) || ''}

            />
        </div>
    )
}

export default function Management() {
    const [productos, setProductos] = useState(null);

    const [invoiceShowPrice, setInvoiceShowPrice] = useState(true)
    const [open, setOpen] = useState(false)
    const [openDelete, setOpenDelete] = useState(false)
    const handleOpen = () => setOpen(true)
    const handleClose = () => setOpen(false)
    const handleOpenDelete = () => {
        setOpenDelete(true)
        setRemove("")
        setMsgSuccessDelete(null)
        setMsgDangerDelete(null)
    }
    const handleCloseDelete = () => {
        setOpenDelete(false)
        setRemove("")
        setMsgSuccessDelete(null)
        setMsgDangerDelete(null)
    }
    const [msgSuccess, setMsgSuccess] = useState(false)
    const [msgDanger, setMsgDanger] = useState(null)
    const [msgSuccessDelete, setMsgSuccessDelete] = useState(null)
    const [msgDangerDelete, setMsgDangerDelete] = useState(null)
    const [spiner, setSpiner] = useState(false)
    const [spinerDelete, setSpinerDelete] = useState(false)
    const [involicePdf, setInvoicePdf] = useState(null)
    const [dateBill, setDateBill] = useState()
    const [loading, setLoading] = useState(true)
    const [filterFast, setFilterFast] = useState(1)

    const [openModalEditTask, setOpenModalEditTask] = useState(false)
    const [idTask, setIdTask] = useState(null)
    const [dateTask, setDateTask] = useState(null)

    const [remove, setRemove] = useState("")

    const columns = useMemo(
        () => [
            {
                Header: "Tarea realizada el día",
                accessor: "date",
                Filter: DateRangeColumnFilter,
                filter: 'dateBetween',
            },
            {
                Header: "Estado",
                accessor: "status",
                Filter: SelectColumnFilter,
                filter: 'includes',
            },
            {
                Header: "Cliente",
                accessor: "client",
            },
            {
                Header: "Trabajador",
                accessor: "worker",
            },
            {
                Header: "Servicio",
                accessor: "service",
                Filter: SelectColumnFilter,
                filter: 'includes',
            },
            {
                Header: "Horas contratadas",
                accessor: "fechaContradata",
            },
            {
                Header: "Horas entrada fichage",
                accessor: "fechaFichage",
            },
            {
                Header: "Facturado",
                accessor: "facturada",
            },
            {
                Header: "ACCIONES",
                accessor: "actions",
            }

        ],
        []
    )


    useEffect(() => {
        getTask()
    }, [filterFast]) // eslint-disable-line react-hooks/exhaustive-deps

    const getTask = async () => {
        setLoading(true)
        allTasksApi({ fast: filterFast }).then(resp => {
            manejarSnapshot(resp.data.data);
            setLoading(false)
        }).catch(error => {
            console.error(error)
        })
    }

    const manejarSnapshot = (snapshot) => {
        const productos = snapshot.map((doc) => {

            // Formatear horas reales de fichaje en 24h y evitar repetir el día si coincide
            const realStart = doc.realStartHour ? moment.unix(doc.realStartHour).locale('es') : null;
            const realEnd = doc.realEndHour ? moment.unix(doc.realEndHour).locale('es') : null;

            let fechaFichage = "";
            if (realStart && realEnd) {
                if (realStart.isSame(realEnd, 'day')) {
                    fechaFichage = `${realStart.format('D MMM, YYYY')} (${realStart.format('HH:mm')} - ${realEnd.format('HH:mm')})`;
                } else {
                    fechaFichage = `${realStart.format('D MMM, YYYY HH:mm')} - ${realEnd.format('D MMM, YYYY HH:mm')}`;
                }
            } else if (realStart) {
                fechaFichage = realStart.format('D MMM, YYYY HH:mm');
            } else if (realEnd) {
                fechaFichage = realEnd.format('D MMM, YYYY HH:mm');
            }
            
            let facturada = "No";
            if (doc.isFacturada == true) {
                facturada = "Sí";
            }

            // Formato de horas: usar 24h. Si mismo día, mostrar "D MMM, YYYY HH:mm - HH:mm"
            let fechaContradata = "";
            const start = doc.startHour ? moment.unix(doc.startHour).locale('es') : null;
            const end = doc.endHour ? moment.unix(doc.endHour).locale('es') : null;

            if (start && end) {
                if (start.isSame(end, 'day')) {
                    fechaContradata = `${start.format('D MMM, YYYY')} (${start.format('HH:mm')} - ${end.format('HH:mm')})`;
                } else {
                    fechaContradata = `${start.format('D MMM, YYYY HH:mm')} - ${end.format('D MMM, YYYY HH:mm')}`;
                }
            } else if (start) {
                fechaContradata = start.format('D MMM, YYYY HH:mm');
            } else if (end) {
                fechaContradata = end.format('D MMM, YYYY HH:mm');
            }

            return {
                ...doc,
                date: `${doc.startHour != undefined ? new Date(parseInt(doc.startHour, 10) * 1000).toISOString().slice(0, 10).toString() : new Date(0).toISOString().slice(0, 10).toString()}`,
                fechaContradata: fechaContradata,
                fechaFichage: fechaFichage,
                startHourTimestamp: doc.startHour,
                endHourTimestamp: doc.endHour,
                worker: `${doc.idWorker.name} ${doc.idWorker.surnames}`,
                client: `${doc.idClient.name} ${doc.idClient.surnames}`,
                realStartHourTimestamp: doc.realStartHour,
                realEndHourTimestamp: doc.realEndHour,
                service: doc.idService.name,
                status: doc.idStatus ? `${doc.idStatus.name}` : "",
                facturada: facturada,
                actions: (<>
                    <Button
                        variant="outlined"
                        color="primary"
                        size="small"
                        onClick={(e) => handleOpenEditTask(e, doc.id)}
                        sx={{
                            borderRadius: 2,
                            paddingLeft: 2,
                            paddingRight: 2,
                            textTransform: 'none',
                            fontWeight: 500,
                            boxShadow: 'none'
                        }}
                    >
                        Editar
                    </Button>
                </>
                ),
            };
        });
        setProductos(productos);
    }

    const [selectedRows, setSelectedRows] = useState({})
    const [taskSelect, setTaskSelect] = useState({})

    const [totalPrice, setTotalPrice] = useState(null)
    const [totalTime, setTotalTime] = useState(null)
    const [totalTimeReal, setTotalTimeReal] = useState(null)
    const [totalUnits, setTotalUnits] = useState(0)

    const selectProduct = async () => {
        setMsgDanger(null)
        setMsgSuccess(false)
        setSpiner(true)

        addTransaction({
            task: taskSelect,
            invoiceShowPrice: invoiceShowPrice,
            dateBill: dateBill
        }).then(resp => {
            if (resp.data.status) {
                handleDownload(resp.data?.data, "factura.pdf")
                // window.open(resp.data?.data, "_blank")
                setInvoicePdf(resp.data?.data)
                setMsgSuccess(true)
            } else {
                setMsgDanger(resp.data?.errors)
            }
            setOpen(false)
            setSpiner(false)
        }).catch(err => {
            setMsgDanger(err?.response?.data?.errors)
            setOpen(false)
            setSpiner(false)
        })
    }

    const handleDownload = (file, filename) => {
        if (file) {
            // Si inicialmente inicia con https
            if (file.startsWith("https")) {
                window.open(file, "_blank")
                return
            }
            apiGetMediaElement(file).then(resp => {
                const base64Content = resp.data?.content;
                const format = 'pdf';
                if (base64Content) {
                    const filenameIn = filename || `archivo.${format || "pdf"}`;
                    const mimeType = getMimeTypeByFormat(format);
                    const link = document.createElement("a");
                    link.href = `data:${mimeType};base64,${base64Content}`;
                    link.download = filenameIn;
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                }
            })
        }
    };

    useEffect(() => {
        let price = 0

        let time = 0
        let timeReal = 0
        let units = 0

        let idTask = []
        for (const position in selectedRows) {
            idTask.push(productos[position].id)
            if (productos[position].idService.serviceType === "KEY_UNIT") {
                // Servicio por unidad
                let unidades = productos[position].serviceUnit
                units += unidades

                // Precio por unidad
                price += parseFloat(productos[position].price) * unidades
            } else {
                // Servicio por hora
                if (productos[position].endHourTimestamp && productos[position].startHourTimestamp) {
                    let diff = DifferenceDate(productos[position].endHourTimestamp, productos[position].startHourTimestamp)
                    let taskTime = (diff.hour * 60) + diff.minute;
                    time += taskTime

                    // Precio por minuto
                    let minutePrice = parseFloat(productos[position].price) / 60
                    price += minutePrice * taskTime
                }
            }

            // Sumar las horas reales trabajadas
            if (productos[position].realStartHourTimestamp && productos[position].realEndHourTimestamp) {
                let diffReal = DifferenceDate(productos[position].realEndHourTimestamp, productos[position].realStartHourTimestamp)
                let taskTimeReal = (diffReal.hour * 60) + diffReal.minute;
                timeReal += taskTimeReal
            }
        }

        if (price === 0) {
            price = "0.00"
        } else {
            price = price.toFixed(2)
        }

        setTaskSelect(idTask)
        setTotalPrice(price)
        setTotalTime(time)
        setTotalTimeReal(timeReal)
        setTotalUnits(units)

    }, [selectedRows]) // eslint-disable-line react-hooks/exhaustive-deps

    // const classes = useStyles()

    const handleChageDate = (event, value) => {
        setDateBill(event.target.value)
    }

    const handleCloseEditTask = () => {
        setOpenModalEditTask(false)
        getTask()
    }


    const handleOpenEditTask = (e, id) => {
        e.stopPropagation();
        //do whatever you want with the row
        openTask(id)
        setOpenModalEditTask(true)
    }

    const openTask = (id) => {
        setIdTask(id)
        setDateTask(null)
    }

    const removeServices = () => {
        if (remove === "eliminar servicios") {

            if (Object.keys(taskSelect).length === 0) {
                setMsgDangerDelete(["No hay servicios seleccionados para eliminar."])
                return;
            }
            setMsgSuccessDelete(null)
            setMsgDangerDelete(null)
            setSpinerDelete(true)
            apiRemoveTasks({
                tasks: taskSelect,
            }).then(resp => {

                if (resp.data.status) {
                    setSpinerDelete(false)
                    setMsgSuccessDelete(["Servicios eliminados correctamente."])
                    setTimeout(() => {
                        handleCloseDelete()
                        setTaskSelect({})
                        getTask()
                    }, 3000)
                } else {
                    setSpinerDelete(false)
                    setMsgDangerDelete(resp.data?.errors)
                }
            }).catch(err => {
                setMsgDangerDelete(err?.response?.data?.errors)
                setSpinerDelete(false)
            })

        } else {
            setMsgDangerDelete(["Escribe 'eliminar servicios' para poder eliminar los servicios seleccionados."])
        }
    }

    const exportExcel = () => {
        apiTaskTimeExport({ tasks: taskSelect })
            .then((resp) => {
                downloaderFile(resp.data.url, "export-task-time.xlsx")
            })
            .catch((err) => {
                console.error(err)
            })
    }

    return (
        <Card>
            <Dialog fullScreen open={openModalEditTask} onClose={handleCloseEditTask}>
                <EditTask
                    handleClose={handleCloseEditTask}
                    openTask={openTask}
                    idTask={idTask}
                    dateTask={dateTask}
                    parent="trabajos"
                />
            </Dialog>
            <div className="cointainer cointainer-bt">
                <h1>Trabajos</h1>
                    {!loading && (
                        <div style={{ display: "flex", justifyContent: "flex-end", gap: 16 }}>
                            <FormControlLabel
                                control={
                                    <Switch
                                        checked={filterFast === 1}
                                        onChange={(event) => {
                                            const newValue = event.target.checked ? 1 : 0;
                                            setFilterFast(newValue);
                                        }}
                                        color="primary"
                                        size="small"
                                    />
                                }
                                label={filterFast === 1 ? "Filtro rápido activado" : "Filtro rápido desactivado"}
                                style={{ marginTop: 8 }}
                            />
                            <Button
                                onClick={exportExcel}
                                color="primary"
                                variant="outlined"
                                style={{ width: 200 }}
                            >
                                Exportar (.xlsx)
                            </Button>
                            <Button
                                onClick={handleOpenDelete}
                                color="primary"
                                variant="outlined"
                                style={{ width: 200 }}
                            >
                                Eliminar servicios
                            </Button>
                            <Button
                                onClick={handleOpen}
                                color="primary"
                                variant="outlined"
                                style={{ width: 200 }}
                            >
                                Generar Factura
                            </Button>
                        </div>
                    )}
            </div>
            {msgSuccess && (
                <Box className="alert-success">
                    La factura se ha generado correctamente
                </Box>
            )}

            {msgDanger && (
                <Box className="alert-danger">
                    {msgDanger.map((item, index) => {
                        return (<span key={index}>{item} <br /></span>)
                    })}
                </Box>
            )}

            <LoadingProgress loading={loading} />

            {!loading && (
                <>
                    <Box
                        sx={{
                            display: 'flex',
                            gap: 4,
                            alignItems: 'center',
                            background: '#eff0f4',
                            borderRadius: 1.5,
                            border: 1,
                            borderColor: '#d7d6d7',
                            p: 2,
                            mb: 2,
                        }}
                    >
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                            <Typography variant="body1">
                                <strong>{totalPrice} €</strong>
                            </Typography>
                            <Typography variant="caption" color="textSecondary" sx={{ ml: 0.5 }}>
                                Precio sin IVA
                            </Typography>
                        </Box>
                        <Typography variant="body1" sx={{ mx: 1 }}>|</Typography>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                            <Typography variant="body1">
                                <strong>{totalTime} m</strong>
                            </Typography>
                            <Typography variant="caption" color="textSecondary" sx={{ ml: 0.5 }}>
                                Minutos vendidos
                            </Typography>
                        </Box>
                        <Typography variant="body1" sx={{ mx: 1 }}>|</Typography>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                            <Typography variant="body1">
                                <strong>{totalTimeReal} m</strong>
                            </Typography>
                            <Typography variant="caption" color="textSecondary" sx={{ ml: 0.5 }}>
                                Minutos realizados
                            </Typography>
                        </Box>
                        <Typography variant="body1" sx={{ mx: 1 }}>|</Typography>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                            <Typography variant="body1">
                                <strong>{totalUnits} u</strong>
                            </Typography>
                            <Typography variant="caption" color="textSecondary" sx={{ ml: 0.5 }}>
                                Unidades vendidas
                            </Typography>
                        </Box>
                    </Box>

                    <Box border={1} className="box-default">
                        <TableFilterBase
                            columns={columns}
                            data={productos || []}
                            selectedRows={selectedRows}
                            onSelectedRowsChange={setSelectedRows}
                            search={false}
                            selectable={true}
                        />
                    </Box>
                </>
            )}

            <Modal
                open={open}
                onClose={handleClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
                className="text-center"
            >
                <Box sx={style}>
                    <Typography id="modal-modal-title" variant="h6" component="h2">
                        Generar Factura
                    </Typography>
                    {!spiner && (
                        <>
                            <Typography id="modal-modal-description" sx={{ mt: 2 }}>
                                Seleccione el tipo de factura que desea visualizar.
                            </Typography>

                            <br />

                            <FormControlLabel
                                control={
                                    <Switch
                                        checked={invoiceShowPrice}
                                        onChange={(event, value) => {
                                            setInvoiceShowPrice(value)
                                        }}
                                        color="primary"
                                    />
                                }
                                label="Mostrar precio por línea"
                            />

                            <div className="mt-2">
                                <TextField
                                    name="dateBill"
                                    label="Día de emisión (Fecha)"
                                    variant="outlined"
                                    type="date"
                                    format="dd/MM/yyyy"
                                    fullWidth
                                    onChange={handleChageDate}
                                    value={dateBill || []}
                                    InputLabelProps={{ shrink: true }}
                                    size="small"
                                />
                            </div>

                            <br />
                            <br />
                            <div style={{ display: "flex", justifyContent: "flex-end", gap: 16 }}>
                                <div style={{ width: "45%" }}>
                                    <Button
                                        onClick={handleClose}
                                        variant="contained"
                                        className="MuiButton-containedCancel"
                                        fullWidth
                                    >
                                        Cancelar
                                    </Button>
                                </div>
                                <div style={{ width: "50%" }}>
                                    <Button
                                        onClick={selectProduct}
                                        variant="contained"
                                        fullWidth
                                        style={{ marginLeft: 8 }}
                                    >
                                        Crear
                                    </Button>
                                </div>
                            </div>
                        </>
                    )}
                    {spiner && (
                        <>
                            <br />
                            <br />
                            <br />
                            <CircularProgress color="success" />
                            <br />
                            <br />
                            <br />
                        </>
                    )}
                </Box>
            </Modal>

            <Modal
                open={openDelete}
                onClose={handleCloseDelete}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
                className="text-center"
            >
                <Box sx={style}>
                    <Typography id="modal-modal-title" variant="h6" component="h2">
                        Eliminar servicios
                    </Typography>
                    {!spinerDelete && (
                        <>
                            <Typography id="modal-modal-description" sx={{ mt: 2 }}>
                                Confirme que desea eliminar los servicios seleccionados.
                            </Typography>

                            <br />


                            <div className="mt-2">
                                <TextField
                                    value={remove}
                                    onChange={(e) => setRemove(e.target.value)}
                                    variant="outlined"
                                    label="Eliminar (eliminar servicios)"
                                    className="form-control"
                                    placeholder="eliminar servicios"
                                    name="remove"
                                    type="text"
                                    fullWidth
                                    size="small"
                                    InputLabelProps={{ shrink: true }}
                                />
                            </div>

                            {msgSuccessDelete && (
                                <Grid item xs={12} md={12} lg={12}>
                                    <Box className="alert-success">
                                        {msgSuccessDelete.map((item, index) => {
                                            return (<span key={index}>{item} <br /></span>)
                                        })}
                                    </Box>
                                </Grid>
                            )}

                            {msgDangerDelete && (
                                <Grid item xs={12} md={12} lg={12}>
                                    <Box className="alert-danger">
                                        {msgDangerDelete.map((item, index) => {
                                            return (<span key={index}>{item} <br /></span>)
                                        })}
                                    </Box>
                                </Grid>
                            )}

                            <br />
                            <br />
                            <div style={{ display: "flex", justifyContent: "flex-end", gap: 16 }}>
                                <div style={{ width: "45%" }}>
                                    <Button
                                        onClick={handleCloseDelete}
                                        variant="contained"
                                        className="MuiButton-containedCancel"
                                        fullWidth
                                    >
                                        Cancelar
                                    </Button>
                                </div>
                                <div style={{ width: "50%" }}>
                                    <Button
                                        onClick={removeServices}
                                        color="primary"
                                        variant="contained"
                                        fullWidth
                                    >
                                        Eliminar
                                    </Button>
                                </div>
                            </div>
                        </>
                    )}
                    {spinerDelete && (
                        <>
                            <br />
                            <br />
                            <br />
                            <CircularProgress color="success" />
                            <br />
                            <br />
                            <br />
                        </>
                    )}


                </Box>
            </Modal>
        </Card>
    );
}
